import { IncentiveOffer, IncentiveOfferType } from 'modules/incentivesMarket/types';

export const filterSellOffers = (offers: IncentiveOffer[]): IncentiveOffer[] =>
  offers.filter((offer) => offer.type === IncentiveOfferType.SELL);

export const filterBuyOffers = (offers: IncentiveOffer[]): IncentiveOffer[] =>
  offers.filter((offer) => offer.type === IncentiveOfferType.BUY);
